import { IDictionary } from '@bimser/core';
import { CustomizedDxColumn } from './generateColumns';

export function calculateCellValueForRelationGrid(this: CustomizedDxColumn, row: IDictionary<any>) {
	const bcDataGrid = this.retrieveDataGridInstance();

	const keyExpr = bcDataGrid.getUniqueDataField();
	const bcRow = bcDataGrid.rows.find(_bcRow => _bcRow.data[keyExpr] === row[keyExpr]);

	if (bcRow) {
		const bcCell = bcRow.cells.find(cell => cell.name === this.name);

		if (bcCell?.text) {
			return bcCell.text;
		}
	}

	return row[this.dataField];
}
